import React from 'react';
import { cpf_cnpj } from '../utils/DictionaryManagementUtils';
import DefaultPanelManuelRecipient from '../components/PanelsComponents/ManuelRecipient/DefaultPanelManuelRecipient';

//= ========================================================================
const Panel_B07a_SendMoneyToCpfManually = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
}) => (
  <DefaultPanelManuelRecipient
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    onConfigChanged={onConfigChanged}
    onGotoEdit={onGotoEdit}
    onStepPressed={onStepPressed}
    language={language}
    manualName={cpf_cnpj}
    isHollow
  />
);

export default Panel_B07a_SendMoneyToCpfManually;
